"use strict";
import { Map } from "immutable";
import { Flash } from "../../components/flash_messages";
export default {
  warning(message, opts = {}) {
    return this.create("warning", message, opts);
  },
  notice(message, opts = {}) {
    return this.create("notice", message, opts);
  },
  success(message, opts = {}) {
    return this.create("success", message, opts);
  },
  create(type, message, opts = {}) {
    return Map({
      __type__: "FlashMessage",
      type,
      message,
      opts
    });
  },
  isFlashMessage(object) {
    return Map.isMap(object) && object.get("__type__") === "FlashMessage";
  },
  perform(flashMessage) {
    const message = flashMessage.get("message");
    const opts = flashMessage.get("opts");
    const type = flashMessage.get("type");
    Flash[type](message, opts);
    return true;
  }
};
